module.exports = __webpack_public_path__ + "img/IMG_1867_L.e0be8467.webp";